import {i18n} from '@yourcoach/i18n';

import type {NotificationEvent} from '../../../../../api/event';
import type {EventContextsMap, EventData} from '../types';

import CrossIcon from '../../../../../assets/icons/secondary/Close.svg';

export const getData = (
  _event: NotificationEvent,
  contexts: EventContextsMap,
): EventData => {
  const {actor, program} = contexts;

  return {
    avatar: actor?.avatar,
    avatarPlaceholder: actor?.name,
    icon: CrossIcon,
    iconGradient: 'danger',
    title: i18n.t('notifications:membership_revoked.title', {
      actorName: actor?.name,
      programTitle: program?.title,
    }),
  };
};
